import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Divider
} from '@mui/material';
import http from '../../commonFunctions/httpClient';

interface ConfirmationPopupProps {
  apiUrl: string;
  id?: string | number;
  confirmMessage: string;
  onConfirm?: (data: any) => void;
  onCancel?: () => void;
  open: boolean;
  onClose: () => void;
  type: IMethodAction
  bodyData?: any; // optional for PUT/POST

}
export type IMethodAction = 'DELETE' | 'PUT' | 'POST';

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  apiUrl,
  id,
  confirmMessage,
  onConfirm,
  onCancel,
  open,
  onClose,
  type,
  bodyData
}) => {

  const handleConfirm = async () => {
    try {
      let response: any;

      console.log('try to delte')
      const message: any = type === 'DELETE' ? 'Deleted successfully!.' : 'Updated successfully!.'
      const fullUrl = id ? `${apiUrl}/${id}` : apiUrl;

      switch (type) {
        case 'DELETE':
          response = await http.del(fullUrl);
          break;
        case 'PUT':
          response = await http.put(fullUrl, bodyData);
          break;
        case 'POST':
          response = await http.post(fullUrl, bodyData);
          break;
        default:
          throw new Error('Invalid API method');
      }


      console.log('response is',response);
      if (onConfirm) onConfirm(response);
    } catch (error: any) {
      console.error('API Error:', error);
      if (onConfirm) onConfirm(error?.response?.data || error?.response || error);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontSize: '1rem' }}>Confirm</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText sx={{
          fontSize: '0.875rem',
          color: '#000',   // 🔥 add this
        }}>{confirmMessage}</DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button size='small' onClick={onCancel || onClose} color="primary">
          Cancel
        </Button>
        <Button size='small' onClick={handleConfirm} color="secondary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
